import { render, staticRenderFns } from "./ListWorkers.vue?vue&type=template&id=d5828e40&scoped=true"
import script from "./ListWorkers.vue?vue&type=script&lang=ts"
export * from "./ListWorkers.vue?vue&type=script&lang=ts"
import style0 from "./ListWorkers.vue?vue&type=style&index=0&id=d5828e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5828e40",
  null
  
)

export default component.exports